import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {LoginPage} from './login.page';
import {MsalGuard, MsalRedirectComponent} from '@azure/msal-angular';
import {OktaAuthGuard} from '../../guards/okta-auth.guard';
import {LoginVeeamPage} from './login-veeam/login-veeam.page';
import {environment} from '../../../environments/environment';
import {LoginLegacyPage} from './login-legacy/login-legacy.page';

const routes: Routes = [
  {
    path: '',
    component: environment.theme === 'veeam' ? LoginVeeamPage : LoginPage,
  },
  {
    path: 'legacy',
    component: LoginLegacyPage,
  },
  {
    path: 'sso',
    component: environment.theme === 'veeam' ? LoginVeeamPage : LoginPage,
    canActivate: [MsalGuard],
    data: {authType: 'sso'}
  },
  {
    path: 'auth',
    component: MsalRedirectComponent
  },
  {
    path: 'okta',
    component: LoginPage
  },
  {
    path: 'okta/auth',
    component: LoginPage,
    data: {authType: 'okta'}
  },
  {
    path: 'okta/alchemist',
    component: LoginPage,
    data: {
      organization: 'alchemist',
    },
    canActivate: [OktaAuthGuard],
  },
  {
    path: 'okta/jazz',
    component: LoginPage,
    data: {
      organization: 'jazz',
    },
    canActivate: [OktaAuthGuard],
  },
  {
    path: 'okta/macmillan',
    component: LoginPage,
    data: {
      organization: 'macmillan',
    },
    canActivate: [OktaAuthGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LoginPageRoutingModule {
}
